<template>
  <div
    class="analytics-wrap pa-0"
  >
      <v-row class="analytics-top-bar">
      <v-col cols="8">
        <div class="analytics-title-wrap">
          <div class="analytics-title">
            Analytics
          </div>
          <!-- <div class="analytics-title" v-else>--</div> -->
        </div>
      </v-col>
      <v-col cols="4" class="text-right pr-7">
      </v-col>
    </v-row>
    <v-row class="ma-0">
      <v-col cols="3">
        <v-card class="reports-card">
          <v-img
            src="../../assets/reports/lifecycle.png"
            height="75px"
            width="75px"
            class="text-center mx-auto"
          ></v-img>
          <v-card-title>
            <div class="text-center mx-auto" style="word-break: break-word;">
              Employee lifecycle
            </div>
          </v-card-title>
          <v-card-subtitle class="ma-0 pa-0 analytics-card-subtitle">
            <div class="text-justify mx-auto">
              Visualize how an employee engages with the company at different stages in an employee lifecycle.
            </div>
          </v-card-subtitle>
          <div class="report-divider">
            <div class="divider">&nbsp;</div>
          </div>
          <v-card-actions>
            <div class="text-center mx-auto">
              <v-btn outlined color="primary" to="/analytics/life-cycle">View report</v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col cols="3">
        <v-card class="reports-card">
          <v-img
            src="../../assets/reports/employee-participation.png"
            height="75px"
            width="75px"
            class="text-center mx-auto"
          ></v-img>
          <v-card-title>
            <div class="text-center mx-auto" style="word-break: break-word;">
              Employee participation rate
            </div>
          </v-card-title>
          <v-card-subtitle class="ma-0 pa-0 analytics-card-subtitle">
            <div class="text-justify mx-auto">
              Employee participation rate is a good indicator of how much they trust your overall internal feedback and subsequent action planning processes.
            </div>
          </v-card-subtitle>
          <div class="report-divider">
            <div class="divider">&nbsp;</div>
          </div>
          <v-card-actions>
            <div class="text-center mx-auto">
              <v-btn outlined color="primary" to="/analytics/participation-rate">View report</v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col cols="3">
        <v-card class="reports-card">
          <v-img
            src="../../assets/reports/chat-participation.png"
            height="75px"
            width="75px"
            class="text-center mx-auto"
          ></v-img>
          <v-card-title>
            <div class="text-center mx-auto" style="word-break: break-word;">
              Chat response rate
            </div>
          </v-card-title>
          <v-card-subtitle class="ma-0 pa-0 analytics-card-subtitle">
            <div class="text-justify mx-auto">
              It represents the rate at which Amara has been accepted in your organization. This is calculated based on the total number of chats sent to the employees vs chats completed.
            </div>
          </v-card-subtitle>
          <div class="report-divider">
            <div class="divider">&nbsp;</div>
          </div>
          <v-card-actions>
            <div class="text-center mx-auto">
              <v-btn outlined color="primary" to="/analytics/response-rate">View report</v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col cols="3">
        <v-card class="reports-card">
          <v-img
            src="../../assets/reports/diversity.png"
            height="75px"
            width="75px"
            class="text-center mx-auto"
          ></v-img>
          <v-card-title>
            <div class="text-center mx-auto" style="word-break: break-word;">
              Gender-wise engagement analysis
            </div>
          </v-card-title>
          <v-card-subtitle class="ma-0 pa-0 analytics-card-subtitle">
            <div class="text-justify mx-auto">
              This report represents how genders are responding to AMARA's interactions and compares their engagement across multiple demographics / drivers / sub drivers.
            </div>
          </v-card-subtitle>
          <div class="report-divider">
            <div class="divider">&nbsp;</div>
          </div>
          <v-card-actions>
            <div class="text-center mx-auto">
              <v-btn outlined color="primary" to="/analytics/diversity-report">View report</v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col cols="3">
        <v-card class="reports-card">
          <v-img
            src="../../assets/reports/custom_report.png"
            height="75px"
            width="75px"
            class="text-center mx-auto"
          ></v-img>
          <v-card-title>
            <div class="text-center mx-auto" style="word-break: break-word;">
              Custom report
            </div>
          </v-card-title>
          <v-card-subtitle class="ma-0 pa-0 analytics-card-subtitle">
            <div class="text-justify mx-auto">Sometimes the insights you request cannot be discovered in a standard report. That’s why Amara allows you to build and save your own custom reports.
            </div>
          </v-card-subtitle>
          <div class="report-divider">
            <div class="divider">&nbsp;</div>
          </div>
          <v-card-actions>
            <div class="text-center mx-auto">
              <v-btn outlined color="primary" to="/analytics/custom-report">View report</v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col cols="3">
        <v-card class="reports-card">
          <v-img
            src="../../assets/reports/driver-engagement.png"
            height="75px"
            width="75px"
            class="text-center mx-auto"
          ></v-img>
          <v-card-title>
            <div class="text-center mx-auto" style="word-break: break-word;">
              Group wise engagement metrics
            </div>
          </v-card-title>
          <v-card-subtitle class="ma-0 pa-0 analytics-card-subtitle">
            <div class="text-justify mx-auto">
              This report represents the engagement metrics of different groups.
            </div>
          </v-card-subtitle>
          <div class="report-divider">
            <div class="divider">&nbsp;</div>
          </div>
          <v-card-actions>
            <div class="text-center mx-auto">
              <v-btn disabled outlined color="primary" to="/analytics/group-metrics-report">Coming soon</v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col cols="3">
        <v-card class="reports-card">
          <v-img
            src="../../assets/reports/driver-engagement.png"
            height="75px"
            width="75px"
            class="text-center mx-auto"
          ></v-img>
          <v-card-title>
            <div class="text-center mx-auto" style="word-break: break-word;">
              Age group wise engagement analysis
            </div>
          </v-card-title>
          <v-card-subtitle class="ma-0 pa-0 analytics-card-subtitle">
            <div class="text-justify mx-auto">
              This report represents the engagement analysis of different age groups.
            </div>
          </v-card-subtitle>
          <div class="report-divider">
            <div class="divider">&nbsp;</div>
          </div>
          <v-card-actions>
            <div class="text-center mx-auto">
              <v-btn disabled outlined color="primary" to="/analytics/age-group-report">Coming soon</v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'analytics',
  components: {
  },
  data () {
    return {
    };
  },
  computed: {
    ...mapState({
      user: state => state.user
    })
  },
  methods: {
  }
};
</script>

<style lang="scss" scoped>
.analytics-wrap {
  .analytics-top-bar {
    // background: #584475;
    background: #050550;
    margin: 0;
    background-image: -webkit-gradient(linear,right top, left top,from(transparent),to(rgba(51,148,255,0.18)));
    .analytics-title {
      color: var(--bg);
      display: flex;
      align-items: center;
      font-size: var(--stats-size-1);
    }
    .analytics-title-wrap {
      display: flex;
    }
  }
  .reports-card {
    // box-shadow: 0 4px 20px 1px rgba(0,0,0,.06), 0 1px 4px rgba(0,0,0,.08) !important;
    box-shadow: 0 4px 16px 11px rgba(0, 0, 0, 0.06), 0 4px 8px rgba(0, 0, 0, 0.1) !important;
    padding: 28px;
    border: 0 !important;
    text-align: center;
    .report-divider {
      text-align: center;
      margin: 0 auto;
      height: 5px;
      display: inline-block;
      .divider {
        width: 60px;
        border-bottom: 2.5px solid rgba(0,0,0,0.1);
      }
    }
    .v-card__title {
      font-size: 16px;
      min-height: 80px;
      line-height: initial !important;
    }
  }
  // display: grid;
  // grid-template-columns: repeat(6, 1fr);
  // margin: 10px;
  // grid-auto-rows: minmax(100px, auto);
  // grid-gap: 20px;
  // .report-card {
  //   text-decoration: none;
  //   &:before {
  //     content: "";
  //     width: 85%;
  //     background: #F9FAFC;
  //     box-shadow: 0px 3px 20px #0000000b;
  //     height: 100%;
  //     margin-top: 0.75rem;
  //     position: absolute;
  //     border-radius: 0.375rem;
  //     margin-left: auto;
  //     margin-right: auto;
  //     right: 0;
  //     left: 0;
  //   }
  //   .report-box {
  //     display: grid;
  //     grid-auto-rows: minmax(100px, auto);
  //     align-items: center;
  //     justify-items: center;
  //     box-shadow: 0px 3px 20px #0000000b;
  //     background-color: var(--bg);
  //     border-radius: 0.375rem;
  //     background-color: var(--bg);
  //     color: var(--color-text);
  //     position: relative;
  //   }
  // }
}
.analytics-card-subtitle {
  min-height: 140px !important;;
}
</style>
